import { generateOptions } from '@/lib/generic.utils'

export function getLast6Years() {
  return Array.from({ length: 6 }, (_, index) => {
    return new Date().getFullYear() - index
  })
}

export function generatePublisherOptions(publishers) {
  return generateOptions({
    collection: publishers,
    sort: false,
    sortBefore: true,
    sortingOptions: {
      sortDataType: 'string',
      sortBy: 'name',
      sortOrder: 'asc'
    }
  })
}
